import { Icon } from "@iconify/react";
import Modal from "../UI/Modal";
import { useSelector, useDispatch } from "react-redux";
import { closePhraseView } from "../../store/reducers/plantels/phrasesByPlantel.reducer";
import Loader from "../UI/Loader";
import Field from "../UI/Field";
import AuditInfo from "../UI/AuditInfo";

const PhraseByPlantelViewModal = () => {
  const dispatch = useDispatch();

  const { viewPhraseModalOpen, selectedPhrase, selectedPhraseLoading } =
    useSelector((state) => state.frasesByPlantel);

  const handleClose = () => {
    dispatch(closePhraseView());
  };

  return (
    <Modal
      open={viewPhraseModalOpen}
      title="Detalle de la frase"
      size="xl"
      onClose={handleClose}
    >
      {selectedPhraseLoading ? (
        <div className="text-center py-5">
          <Loader type="spinner" size="lg" delay={0} />
        </div>
      ) : selectedPhrase ? (
        <div className="row g-4">
          <div className="col-12">
            <Field
              label="Frase"
              value={selectedPhrase.frase}
              icon="mdi:format-quote-open"
              justify
            />
          </div>

          <div className="col-md-6">
            <Field
              label="Talento asociado"
              value={selectedPhrase.talento_nombre || "Sin talento"}
              icon="mdi:account-star-outline"
            />
          </div>

          <div className="col-md-6">
            <Field
              label="Estado"
              value={
                selectedPhrase.is_active ? (
                  <span className="badge bg-success-subtle text-success">
                    Activa
                  </span>
                ) : (
                  <span className="badge bg-danger-subtle text-danger">
                    Inactiva
                  </span>
                )
              }
              icon="mdi:toggle-switch"
            />
          </div>

          <div className="col-12">
            <AuditInfo
              createdAt={selectedPhrase.created_at}
              updatedAt={selectedPhrase.updated_at}
              createdBy={selectedPhrase.created_by}
              updatedBy={selectedPhrase.updated_by}
            />
          </div>
        </div>
      ) : (
        <div className="text-center py-5">
          <Icon icon="mdi:alert-circle" width="48" className="text-muted" />
          <p className="text-muted mt-3">No se pudo cargar la información</p>
        </div>
      )}
    </Modal>
  );
};

export default PhraseByPlantelViewModal;
